module.exports = __webpack_public_path__ + "static/la-ventures--jasmin-brown-d8dadd3d4b1000a53478320596a18e69.mp4";